/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import { modelsFiltered } from '#selectors/entities/models.js';
import { selectModelsTableFilters, selectMapMetric } from '#selectors/ui/modelsTable.js';
import { setMapMetric } from '#actions/models/modelsTable.js';
import ModelsMap from './ModelsMap.jsx';

const mapStateToProps = state => {
  const filters = selectModelsTableFilters(state);
  const data = modelsFiltered(state, { ...filters });
  return {
    data,
    metric: selectMapMetric(state),
  };
};

const mapDispatchToProps = dispatch => ({
  onSetMetric: metric => dispatch(setMapMetric(metric)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModelsMap);
